// getters
const adminTurns = state => state.adminTurns

export default {
  adminTurns
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/turns/getters.js